import type { UI } from '@/v2/types';

import { createCtx } from '@/v2/utils/createCtx';

export const [useNavigation, NavigationProvider] =
  createCtx<Array<UI.Navigation>>();
